
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/produtos/[slug]/contacto",
      function () {
        return require("private-next-pages/produtos/[slug]/contacto.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/produtos/[slug]/contacto"])
      });
    }
  